import type { IMediaFile } from "@/shared/types";
import { prepBlurhashUrl } from "@/shared/utils";
import type { TElement } from "@editor/modules/media-lib/types";
import { nanoid } from "@reduxjs/toolkit";

interface IProps {
  url: string;
  alt?: string | undefined;
  width?: number | undefined;
  height?: number | undefined;
  shouldUpload?: boolean | undefined;
}

export const makeImagesPanelImageElement = ({
  url,
  alt,
  width,
  height,
  shouldUpload = true,
}: IProps): TElement => ({
  category: "Images",
  element: "Image",
  id: nanoid(),
  json: {
    id: nanoid(),
    children: [],
    type: "element",
    settings: {
      src: appendUploadParam(url, shouldUpload),
      alt,
      shadow: "none",
      round: "8px",
      width: "75",
      selectedLinkType: "none",
      horizontalAlignment: "center",
      shape: "free",
      overlayOpacity: "80",
      metadata: {
        width,
        height,
        scale: 1,
        translateX: 50,
        translateY: 50,
      },
      name: "Image",
    },
  },
  order: 0,
  previewImage: null,
});

interface IImageFromFileProps {
  mediaFile: IMediaFile;
  shouldUpload?: boolean;
  alt?: string;
}

export const makeImageElementFromMediaFile = ({
  mediaFile,
  shouldUpload = false,
  alt,
}: IImageFromFileProps) => {
  let url = mediaFile.url;
  const hash = mediaFile.metadata?.imageBlurhash;
  if (hash) url = prepBlurhashUrl(url, hash);

  return makeImagesPanelImageElement({
    url,
    width: mediaFile.metadata?.width,
    height: mediaFile.metadata?.height,
    shouldUpload: shouldUpload,
    alt,
  });
};

function appendUploadParam(url: string, shouldUpload: boolean) {
  if (!shouldUpload) return url;
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}upload=true`;
}
